import React from 'react';
import { Slide } from 'react-slideshow-image';
import classNames from 'classnames/bind';
import Image from '../../atoms/ImageView';

import styles from './PlpExtendedBanner.module.pcss';

const cx = classNames.bind(styles);

const setHotspots = (bannerData, isWeb) => {
  let { hotspots = [] } = bannerData;
  return hotspots.map(({ hotspotUrl, width, height, x, y }, index) => {
    return (
      <a
        key={index}
        target={isWeb ? '_blank' : '_self'}
        style={{
          position: 'absolute',
          left: `${x}%`,
          top: `${y}%`,
          width: `${width}%`,
          height: `${height}%`
        }}
        href={hotspotUrl}
        rel="noreferrer"
      />
    );
  });
};

const PlpExtendedBanner = ({ banners = [], extendedBannerCarouselTimer = 5, isWeb = false }) => {
  const slickSettings = {
    arrows: false,
    duration: extendedBannerCarouselTimer * 1000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    autoplay: true
  };
  return (
    <div className="plpExtendedBannerImages">
      {banners.length > 1 ? (
        <Slide {...slickSettings}>
          {banners.map(banner => (
            <div className={cx('plpExtendedBannerContainer')}>
              <Image src={banner?.bannerUrl} className={cx('plpExtendedBanner')} />
              {banner && setHotspots(banner, isWeb)}
            </div>
          ))}
        </Slide>
      ) : (
        <div className={cx('plpExtendedBannerContainer')}>
          <Image src={banners[0]?.bannerUrl} className={cx('plpExtendedBanner')} />
          {banners && setHotspots(banners[0], isWeb)}
        </div>
      )}
    </div>
  );
};

export default PlpExtendedBanner;
